import { render } from "./PostFeed.vue?vue&type=template&id=54dafb46&scoped=true"
import script from "./PostFeed.vue?vue&type=script&lang=js"
export * from "./PostFeed.vue?vue&type=script&lang=js"

import "./PostFeed.vue?vue&type=style&index=0&id=54dafb46&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54dafb46"]])

export default __exports__